{
  "title": "帳號管理",
  "account": "帳號",
  "name": "姓名",
  "changeName": "變更姓名",
  "changeNameIcon": "fa-solid fa-user-pen",
  "oSecret": "舊密碼",
  "nSecret": "新密碼",
  "changeSecret": "變更密碼",
  "changeSecretIcon": "fa-solid fa-pen-to-square",
  "oSecretPlaceholder": "請輸舊密碼變更資料",
  "nSecretPlaceholder": "輸入新密碼變更密碼",
  "wrongSecret": "密碼輸入不正確",
  "changed": "修改成功"
}